import { ISobCompetitor } from 'partner360/models/ISobCompetitor'

import { getCalckedFYFields } from './getCalckedFYFields'
import { getCalckedSellThruFields } from './getCalckedSellThruFields'
import { isCurrentFYearField } from './isCurrentFYearField'

interface IGetChangedItemWithUpdatedSellThruAndYoYFields {
  item: ISobCompetitor
  field: string
  value: number
  hpItem?: ISobCompetitor
}
export const getChangedItemWithUpdatedSellThruAndYoYFields = ({
  item,
  hpItem,
  value,
  field,
}: IGetChangedItemWithUpdatedSellThruAndYoYFields) => {
  const calckedSellThru = getCalckedSellThruFields({ field, value, hpItem, item })

  const itemWithChangedSellThru = { ...item, ...calckedSellThru }

  const calckedFYFields = getCalckedFYFields({
    isCurrentYearField: isCurrentFYearField(field),
    hpItem,
    item: itemWithChangedSellThru,
  })

  return { ...itemWithChangedSellThru, ...calckedFYFields }
}
